<div class="flex flex-col gap-5 w-full">

  <!-- Cabeçalho -->
  <div class="bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-zinc-800 px-6 py-4">
    <div class="flex items-center justify-between flex-wrap gap-3">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-red-50 dark:bg-red-950/40 flex items-center justify-center flex-shrink-0">
          <i class="pi pi-chart-bar text-xl text-[#E41B2E]"></i>
        </div>
        <div>
          <h1 class="text-xl font-bold text-gray-800 dark:text-white leading-tight">Meta de Bonificação</h1>
          <p class="text-sm text-gray-500 dark:text-gray-400">Acompanhamento em tempo real do progresso</p>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <p-button [icon]="autoRefresh ? 'pi pi-pause' : 'pi pi-play'"
                  [label]="autoRefresh ? 'Pausar atualização' : 'Atualização automática'"
                  [severity]="autoRefresh ? 'warn' : 'secondary'"
                  [outlined]="true" size="small"
                  (onClick)="toggleAutoRefresh()"/>
        <p-button icon="pi pi-refresh" label="Atualizar" severity="secondary"
                  [outlined]="true" size="small" (onClick)="carregarProgresso()"/>
        <p-button icon="pi pi-cog" pTooltip="Configurar metas" severity="secondary"
                  [text]="true" (onClick)="irParaAdmin()"/>
      </div>
    </div>
  </div>

  @if (loading) {
    <p-skeleton height="14rem" styleClass="rounded-xl"/>
  } @else if (metas.length === 0) {
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 p-10 flex flex-col items-center gap-3">
      <i class="pi pi-chart-bar text-5xl text-gray-300 dark:text-zinc-600"></i>
      <p class="text-gray-500 dark:text-gray-400 text-lg font-medium">Nenhuma meta configurada</p>
      <p class="text-sm text-gray-400 dark:text-zinc-500">Acesse o painel de administração para criar metas de bonificação.</p>
      <p-button label="Configurar metas" icon="pi pi-cog" styleClass="btn-red" (onClick)="irParaAdmin()"/>
    </div>
  } @else {

    <!-- Seletor de meta -->
    @if (metas.length > 1) {
      <div class="quick-filters bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 px-3 py-1.5 flex flex-col gap-0.5 w-fit">
        <span class="text-[9px] text-gray-400 uppercase tracking-wide">Meta</span>
        <p-select [(ngModel)]="metaSelecionada" [options]="metas" optionLabel="nome" size="small"
                  (onChange)="onMetaChange()" [style]="{minWidth: '280px'}"/>
      </div>
    }

    @if (progressoLoading) {
      <div class="flex flex-col gap-3">
        <p-skeleton height="12rem" styleClass="rounded-xl"/>
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-3">
          @for (_ of [1,2,3,4]; track $index) { <p-skeleton height="7rem" styleClass="rounded-xl"/> }
        </div>
        <p-skeleton height="20rem" styleClass="rounded-xl"/>
      </div>
    } @else if (progresso) {
      <app-meta-progresso-panel [progresso]="progresso"/>
    }
  }

</div>
